const DEFAULT_ROLES = [
  "Product Owner",
  "Team Member", 
  "Scrum Master",
  "Stakeholder",
];

const PORTFOLIO_STRATEGY_ROLES = [
  "Owner", // Changed from "Product Owner"
  "Team Member",
  "Agile facilitator", // Changed from "Scrum Master"
  "Stakeholder",
];

export const getRolesForPackageData = (useCustomRoleMapping?: boolean) => {
  return useCustomRoleMapping ? PORTFOLIO_STRATEGY_ROLES : DEFAULT_ROLES;
};